import { cn } from "@/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

const buttonVariants = cva(
  "btn transition-all duration-200 rounded-lg",
  {
    variants: {
      variant: {
        primary: "btn-primary",
        outline: "btn-outline btn-primary",
        ghost: "btn-ghost text-primary",
        secondary: "btn-secondary",
        accent: "btn-accent",
      },
      size: {
        sm: "btn-sm text-sm rounded-xl",
        md: "btn-md rounded-xl",
        lg: "btn-lg rounded-xl",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
)

interface IButton
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  children: React.ReactNode
}

const Button = ({ className, variant, size, children, ...props }: IButton) => {
  return (
    <button
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button